import { Component, inject } from '@angular/core';
import { BrandingService } from '@insolution/branding-util';

@Component({
  selector: 'lib-entry-layout',
  imports: [],
  templateUrl: './entry-layout.html',
  styleUrl: './entry-layout.scss',
})
export class EntryLayout {
  protected logoUrl = inject(BrandingService).logoUrl;
}
